import { render, staticRenderFns } from "./3_donationInfo.vue?vue&type=template&id=6793df52"
import script from "./3_donationInfo.vue?vue&type=script&lang=js"
export * from "./3_donationInfo.vue?vue&type=script&lang=js"
import style0 from "./3_donationInfo.vue?vue&type=style&index=0&id=6793df52&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports